export const NEW_MOVE_LTE_ADDRESS = 'Same as your new LTE Home service address';
export const NEW_MOVE_5G_ADDRESS = 'Same as your new service address';
export const NEW_SHIPPING_ADDRESS = 'Enter a new shipping address';
export const SAME_5G_BILLING_ADDRESS = 'Same as 5G billing address';
export const SAME_LTE_BILLING_ADDRESS = 'Same as LTE Home Internet billing address';

export const SHIPPING_ADDRESS = 'Shipping address';

export const CURRRENT_VIEW = {
  IS_ISPU_SELECTED: 'IS_ISPU_SELECTED',
  IS_NON_ISPU_OPTION_SELECTED: 'IS_NON_ISPU_OPTION_SELECTED',
};

export const MODAL_VIEW = {
  SHOW_AUTHENTICATION_MODEL: 'SHOW_AUTHENTICATION_MODEL',
  HIDE_AUTHENTICATION_MODEL: 'HIDE_AUTHENTICATION_MODEL',
};

export const InputErrorMsg = {
  addressLine1: 'Please enter a valid shipping address 1',
  city: 'Please enter a valid city',
  state: 'Please enter a valid state',
  zipCode: 'Please enter a valid ZIP code',
  address2: 'Enter a valid appt/unit number',
};

export const addressMap = {
  LTE: [NEW_MOVE_LTE_ADDRESS, SAME_LTE_BILLING_ADDRESS, NEW_SHIPPING_ADDRESS],
  DEFAULT: [NEW_MOVE_5G_ADDRESS, SAME_5G_BILLING_ADDRESS, NEW_SHIPPING_ADDRESS],
};
export const SHIPPING_ADDRESS_SELECT = 'SHIPPING_ADDRESS_SELECT';
export const UNIT_SELECT = 'UNIT';
export const SHIPPING_UNAVAILABLE_ALERT = {
  "title": "We’ve updated your setup date based on the estimated delivery date of your equipment.",
  "description": "If you want to make any changes, you can edit your setup date or equipment delivery method.",
}